import React from 'react';
import PropTypes from 'prop-types';

import { SUBSTANCE_USE, SUBSTANCE_USE_REVIEW } from 'config/formSections/substanceUse';

import connectSubsection from 'components/Section/shared/SubsectionConnector';

import * as formTypes from 'constants/formTypes';
import Show from 'components/Form/Show';
import { isPVQForm } from 'helpers/form';
import ConnectedNegativeImpacts from '../Alcohol/NegativeImpacts';
import ConnectedOrderedCounselings from '../Alcohol/OrderedCounselings';
import ConnectedVoluntaryCounselings from '../Alcohol/VoluntaryCounselings';
import ConnectedReceivedCounselings from '../Alcohol/ReceivedCounselings';
import ConnectedAlcoholSupplemental from '../Alcohol/AlcoholSupplemental';
import ConnectedDrugUses from '../Drugs/DrugUses';
import ConnectedDrugInvolvements from '../Drugs/DrugInvolvements';
import ConnectedDrugClearanceUses from '../Drugs/DrugClearanceUses';
import ConnectedDrugPublicSafetyUses from '../Drugs/DrugPublicSafetyUses';
import ConnectedDrugNegativeImpact from '../Drugs/DrugNegativeImpact';
import ConnectedPrescriptionUses from '../Drugs/PrescriptionUses';
import ConnectedOrderedTreatments from '../Drugs/OrderedTreatments';
import ConnectedVoluntaryTreatments from '../Drugs/VoluntaryTreatments';
import ConnectedDrugSupplementalUses from '../Drugs/DrugSupplementalUses';
import ConnectedDrugSupplementalPublicSafetyUses from '../Drugs/DrugSupplementalPublicSafetyUses';
import ConnectedThcClearanceUses from '../Thc/ThcClearanceUses';
import ConnectedThcInvolvements from '../Thc/ThcInvolvements';
import ConnectedThcPublicSafetyUses from '../Thc/ThcPublicSafetyUses';
import ConnectedThcUses from '../Thc/ThcUses';

const sectionConfig = {
  section: SUBSTANCE_USE.name,
  store: SUBSTANCE_USE.store,
  subsection: SUBSTANCE_USE_REVIEW.name,
};

export const Review = function ({
  requireDrugWhileSafetySection,
  requireDrugWithClearanceSection,
  requireAlcoholSections,
  requireAlcoholReceivedCounselingsSection,
  requireDrugSupplementalSection,
  requireAlcoholSupplementalSection,
  formType,
}) {
  const props = {
    required: true,
    scrollIntoView: false,
    formType: '',
  };

  const sectionDivider = <hr className="section-divider" />;

  const isPvq = isPVQForm(formType);
  return isPvq ? (
    <div>
      <ConnectedDrugUses {...props} />
      {sectionDivider}
      <ConnectedDrugNegativeImpact {...props} />
      {sectionDivider}
      <ConnectedDrugInvolvements {...props} />

      {sectionDivider}
      <ConnectedDrugClearanceUses {...props} />

      {sectionDivider}
      <ConnectedDrugPublicSafetyUses {...props} />

      <ConnectedPrescriptionUses {...props} />
      {sectionDivider}
      <ConnectedOrderedTreatments {...props} />
      {sectionDivider}
      <ConnectedVoluntaryTreatments {...props} />

      {sectionDivider}
      <ConnectedThcUses {...props} />
      {sectionDivider}
      <ConnectedThcInvolvements {...props} />

      {sectionDivider}
      <ConnectedThcClearanceUses {...props} />

      {sectionDivider}
      <ConnectedThcPublicSafetyUses {...props} />

      {formType.includes('B') && (
        <span>
          {sectionDivider}
          <ConnectedNegativeImpacts {...props} />
          {sectionDivider}
          <ConnectedOrderedCounselings {...props} />
          {sectionDivider}
          <ConnectedVoluntaryCounselings {...props} />
        </span>
      )}

    </div>
  ) : (
    <div>
      <ConnectedDrugUses {...props} />
      <Show when={formType !== formTypes.SF852013}>
        {sectionDivider}
        <ConnectedDrugInvolvements {...props} />

        {requireDrugWithClearanceSection && (
          <span>
            {sectionDivider}
            <ConnectedDrugClearanceUses {...props} />
          </span>
        )}

        {requireDrugWhileSafetySection && (
          <span>
            {sectionDivider}
            <ConnectedDrugPublicSafetyUses {...props} />
          </span>
        )}

        {sectionDivider}
        <ConnectedPrescriptionUses {...props} />
        {sectionDivider}
        <ConnectedOrderedTreatments {...props} />
        {sectionDivider}
        <ConnectedVoluntaryTreatments {...props} />

        {requireDrugSupplementalSection && (
          <>
            {sectionDivider}
            <ConnectedDrugSupplementalUses {...props} />
            {sectionDivider}
            <ConnectedDrugSupplementalPublicSafetyUses {...props} />
          </>
        )}

        {requireAlcoholSections && (
          <span>
            {sectionDivider}
            <ConnectedNegativeImpacts {...props} />
            {sectionDivider}
            <ConnectedOrderedCounselings {...props} />
            {sectionDivider}
            <ConnectedVoluntaryCounselings {...props} />
            {requireAlcoholReceivedCounselingsSection && (
              <>
                {sectionDivider}
                <ConnectedReceivedCounselings {...props} />
              </>
            )}
            {requireAlcoholSupplementalSection && (
              <>
                {sectionDivider}
                <ConnectedAlcoholSupplemental {...props} />
              </>
            )}
          </span>
        )}
      </Show>
    </div>
  );
};

Review.propTypes = {
  requireDrugWhileSafetySection: PropTypes.bool,
  requireDrugWithClearanceSection: PropTypes.bool,
  requireAlcoholSections: PropTypes.bool,
  requireAlcoholReceivedCounselingsSection: PropTypes.bool,
  requireDrugSupplementalSection: PropTypes.bool,
  requireAlcoholSupplementalSection: PropTypes.bool,
};

Review.defaultProps = {
  requireDrugWhileSafetySection: true,
  requireDrugWithClearanceSection: true,
  requireAlcoholSections: true,
  requireAlcoholReceivedCounselingsSection: true,
  requireDrugSupplementalSection: false,
  requireAlcoholSupplementalSection: false,
};

export default connectSubsection(Review, sectionConfig);
